import { render, staticRenderFns } from "./SalesReportDetailsModal.vue?vue&type=template&id=54752b7c"
import script from "./SalesReportDetailsModal.vue?vue&type=script&lang=js"
export * from "./SalesReportDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports